import { render, staticRenderFns } from "./PersonalManagement.vue?vue&type=template&id=3b54cb98&"
import script from "./PersonalManagement.vue?vue&type=script&lang=js&"
export * from "./PersonalManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports